import {Footer, Profile} from "../../components";

export function ProfilePage() {
    return (
        <div>
            <Profile/>
            <Footer/>
        </div>
    )
}